/* The border and padding sit INSIDE the 100 % (F-UIX-016): otherwise a full-width field is wider than a phone. */
.textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 10px var(--space-3);
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
  resize: vertical;
}

/* Same indicator as `Input` (decision D-UX-5). */
.textarea:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.textarea[aria-invalid="true"] {
  border-color: var(--danger-text);
}

.textarea::placeholder {
  color: var(--text-subtle);
}

/* Inside a box that draws the border and the focus ring (`:focus-within`): the mockup's `.prompt-ta`. */
.bare {
  box-sizing: border-box;
  width: 100%;
  padding: var(--space-2);
  border: 0;
  background: transparent;
  color: var(--text);
  font: inherit;
  resize: none;
  outline: none;
}

.bare::placeholder {
  color: var(--text-subtle);
}

/*
 * `autoGrow`: the height comes from the content through a custom property set from script, never
 * more than the ceiling (40 % of the viewport, about twelve lines), and then the field scrolls inside.
 * Before the first measure the `rows` attribute sets the height.
 */
.grow {
  block-size: var(--textarea-grow-height, auto);
  max-block-size: min(40vh, 18em);
  overflow-y: auto;
  resize: none;
}
